import type { BadgeProps } from '@time-line/components/common';
import { Badge } from '@time-line/components/common';
import { env } from 'lib/constants/env';
import type { ProductBullet } from 'types/cms/ProductBullet';

export interface ProductBadgeProps extends BadgeProps {
  availableForSale?: boolean;
  productBullet?: ProductBullet;
  isPreorder?: boolean;
}

export function ProductBadge({
  availableForSale,
  productBullet,
  isPreorder,
  ...rest
}: ProductBadgeProps) {
  const BADGE_STYLES = {
    regular: 'gray',
    highlight: 'red',
    disabled: 'blackAlpha',
  } as const;

  if (
    env.NEXT_PUBLIC_OOS_BADGE_DISABLED !== true &&
    availableForSale === false
  ) {
    return (
      <Badge
        className="badge--product"
        variant="subtle"
        colorScheme="gray"
        {...rest}
      >
        Sold out
      </Badge>
    );
  }
  if (productBullet?.label && productBullet?.style) {
    return (
      <Badge
        className="badge--product"
        variant="solid"
        colorScheme={BADGE_STYLES[productBullet.style]}
        {...rest}
      >
        {productBullet.label}
      </Badge>
    );
  }
  if (isPreorder) {
    return (
      <Badge
        className="badge--product"
        variant="solid"
        colorScheme="red"
        {...rest}
      >
        Pre-order
      </Badge>
    );
  }

  return null;
}
